//
//
//
//
//
//
//

export default {
  props: {
    btnName: {
      type: String,
      default: '',
    },
  },
}
